import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../Environment/environment';

@Injectable({
  providedIn: 'root'
})
export class SendMailService {
basePath:string="";
  constructor(private http:HttpClient) { 
    this.basePath = environment.apiUrl;
  }
  public sendPDFToAPI(pdfBlob: Blob, configNumber: any, quoteData: any) {
    debugger;
    const apiUrl = this.basePath + `UserRegistration/sendemail?customerName=${encodeURIComponent(JSON.stringify(quoteData))}`;  // Your C# API URL
    // Create FormData customerName
    const formData = new FormData();
  formData.append('pdf', pdfBlob, 'Quote_' + configNumber + '.pdf');  // Name the file as 'Quote_<configNumber>.pdf'

  // Send POST request with FormData and customer data as query parameter
  this.http.post(apiUrl, formData).subscribe(response => {
    console.log('PDF and customer data sent to server successfully!', response);
  });
  }
  
}
